<template>
  <div class="inner-box">
    <div slot="content">
      <el-form size="medium" v-on:submit.prevent>
        <div class="content-name">
          <h2 class="dp-ib">{{ routeName }}</h2>
          <el-form-item label-width="0px" style="float: right;">
            <el-button type="primary" icon="el-icon-search" @click="goOpen">
              {{ this.$i18n.messages[this.$store.state.locale].search }}
            </el-button>

            <el-button type="primary" icon="el-icon-check" @click="save">
              반품저장
            </el-button>
            <el-button type="danger" icon="el-icon-delete-solid" @click="cancel">
              반품취소
            </el-button>
            <el-button type="primary" icon="el-icon-plus" @click="openMateReturnWrite">
              반품자재등록
            </el-button>
            <el-button type="info" icon="el-icon-printer" @click="openReturnTagPrintModal">
              반납TAG출력
            </el-button>
          </el-form-item>
        </div>
      </el-form>
      <div class="search-form">
        <el-form size="mini">
          <el-row style="margin-bottom: 0px;">
            <el-col :span="12">
              <el-form-item label="반품일자" label-width="100px">
                <el-row>
                  <el-col>
                    <el-col :span="11">
                      <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                    <el-col :span="1" style="text-align: start;">-</el-col>
                    <el-col :span="12">
                      <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 90%;" value-format="yyyy-MM-dd"></el-date-picker>
                    </el-col>
                  </el-col>
                </el-row>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="반품구분" label-width="100px">
                <el-select v-model="form.outType" >
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['outType']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="진행단계" label-width="100px">
                <el-select v-model="form.procYn" >
                  <el-option value=''>전체</el-option>
                  <el-option
                      v-for="item in combos['procYn']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row style="margin-bottom: 0px;">
            <el-col :span="6">
              <el-form-item label="제조사" label-width="100px">
                <el-select v-model="form.maker">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['maker']"
                      :key="item.value"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="제품군" label-width="100px">
                <el-select v-model="form.itemGroup">
                  <el-option value='' label="전체">전체</el-option>
                  <el-option
                      v-for="item in combos['itemGroup']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="품번" label-width="100px">
                <el-input type="text" v-model="form.itemCd" style="width: 80%;"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </el-form>
      </div>
    </div>



    <div class="table-area">
      <div class="table-b">
        <div class="table-header">
          <div class="grid-tbl-box">
            <ag-grid-vue
                ref="grid"
                :style="gridStyle"
                class="ag-theme-alpine"
                :column-defs="columnDefs"
                :grid-options="mainGridOptions"
                :row-data="data"
                :default-col-def="defaultColDef"
                :framework-components="frameworkComponent"
                :statusBar="statusBar"
                :context="context"
                :enableRangeSelection="true"
                @selection-changed="onSelectionChangedSub"
                @grid-ready="onReadyMain" />
          </div>
        </div>
      </div>
    </div>

    <el-form size="mini" >
      <div>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" style="float: right;" icon="el-icon-files" @click="updateCount()">
            수정
          </el-button>
        </el-form-item>
      </div>
    </el-form>
    <mate-ReturnList-Info ref="mateReturnListInfo" :mateReturnListDetail="mateReturnListDetail" style="height: 100%"/>



  </div>
</template>

<script>
import DatepickerCellRenderer from "@/components/agGrid/datepicker-cell-renderer";
import MaskEditCellRenderer from "@/components/agGrid/maskedit-cell-renderer";
import SelectCellRenderer from "@/components/agGrid/select-cell-renderer";
import CheckboxCellRenderer from "@/components/agGrid/checkbox-cell-renderer";
import RadioCellRenderer from "@/components/agGrid/radio-cell-renderer";
import NumberInputCellRender from "@/components/agGrid/numberinput-cell-renderer";
import InputCellRender from "@/components/agGrid/input-cell-renderer";
import ButtonCellRenderer from "@/components/agGrid/button-cell-renderer";
import MateReturnListInfo from "@/components/WorkMng/MateReturnListInfo";
import MateReturnWrite from "@/components/LucomsModal/MateReturnWrite";

import ReturnTagPrinter from "@/components/Agent/MateReturnList/ReturnTagPrinter.vue";

/**
 * url
 * @param  {...any} args 
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  props: {
  },
  components: {MateReturnListInfo},
  data() {
    return {
      data: [],
      result: [],
      form: {

        companyId : '',
        startDt : this.$moment().add(-7, 'days').format('YYYY-MM-DD'),
        endDt : this.$moment().format('YYYY-MM-DD'),
        asAgentId : 0,
        outType : '',                     // 반품구분
        procYn : '',                      // 진행단계
        maker : '',                       // 제조사
        itemGroup : '',                   // 제품군
        itemCd : '',                      // 품번
        sortType : '',                    // 승인/정산처리유형*/
        page : 1,
        totalPage : 9999,
        curPage : 0,
        totalCount : 9999,
        processTime : ''

      },
      combos: {
        'outType' : [],           // 반품구분
        'procYn' : [],            // 진행단계
        'maker' : [],            //제조사
        'itemGroup' : [],        //제품군
      },
      changeCatIdShow : false,
      //startDt: this.$moment().add(-1, 'month').startOf('month').format('YYYY-MM-DD'),
      //endDt: this.$moment().format('YYYY-MM-DD'),
      // AG-GRID OPTION [START]
      gridStyle : 'padding-top: 0px; width: 100%;height: 650px; min-height:100px;',
      defaultColDef: {
        resizable: true
        , filter:true
        , sortable: true
      },
      mainGridApi: null,
      mainColumnApi: null,
      mainGridOptions: {
        enableColResize: true,
        enableFilter: true,
        animateRows: false,
        enableSorting: true,
      },
      context: {
        //checkbox 전체 체크 이벤트 추가
        headerAllCheckEvent: this.allCheckEvnet
      },
      columnDefs: [],
      frameworkComponent : {
        datePicker: DatepickerCellRenderer,
        maskEdit: MaskEditCellRenderer,
        select: SelectCellRenderer,
        checkBox: CheckboxCellRenderer,
        radio: RadioCellRenderer,
        numberInput: NumberInputCellRender,
        input: InputCellRender,
        button: ButtonCellRenderer
      },
      statusBar: null,
      mateReturnListDetail: [],
      btnSaveVisible : false,
      btnCancelVisible : false
    }
  },
  methods: {
    onReadyMain() {
      this.mainGridApi = this.mainGridOptions.api;
      this.mainColumnApi = this.mainGridOptions.columnApi;

      this.init();
    },
    createMainColumnDefs() {
      this.columnDefs = [
        {headerName:'No', field:'no', width:80, cellStyle:{textAlign: 'center'},
          valueFormatter: function(params) {
            return params.node.rowIndex+1;
          }
        },
        {headerName:'선택', field: 'chk', width: 80, cellRenderer: 'checkBox',
          cellRendererParams: (params) => {
            function chkDisable(procYn) {
              return  procYn === 'YY' ? true : false
            }
            return {trueValue: 'Y', falseValue: 'N', disable: chkDisable(params.data.procYn) }
          }
        },
        {headerName:'반품일자', field:'outDt', width:120, cellStyle:{textAlign: 'center'}, cellRenderer: 'datePicker'},
        {headerName:'반품구분', field:'outType', width:120, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.outType === 'UseNoItem' ? "미사용자재" : (params.data.outType === 'BadItem' ? "불량자재" : (params.data.outType === 'UseItem' ? "사용자재" : ""))
          }
        },
        {headerName:'제조사', field:'makerNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'제품군', field:'itemGroupNm', width:120, cellStyle:{textAlign: 'center'}},
        {headerName:'품번', field:'itemCd', width:180},
        {headerName:'픔명', field:'itemNm', width:320},
        {headerName:'반품수량', field:'inBadQty', width:110, cellStyle:{textAlign: 'center'}},
        {headerName:'사이트', field:'siteNm', width:170},
        {headerName:'처리유형', field:'srcId1', width:110, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.srcId1 === 'AsRepairItem' ? "AS 회수" : (params.data.srcId1 === 'BsMaItem' ? "BS/MA 회수" : "")
          }
        },
        {headerName:'장애처리일자', field:'procDt', width:130, cellStyle:{textAlign: 'center'}, cellRenderer: 'datePicker'},
        {headerName:'진행단계', field:'procYn', width:120, cellStyle:{textAlign: 'center'},
          valueGetter: (params) => {
            return params.data.procYn === 'NN' ? "반품대기" : (params.data.procYn === 'YN' ? "반품의뢰" : (params.data.procYn === 'YY' ? "반품확정" : ""))
          }
        },
        // {headerName:'반납TAG', field:'returnTag', width:130, cellStyle:{textAlign: 'center'}, 
        //   cellRenderer: 'button',
        //   cellRendererParams: {
        //     name:  'TAG출력',
        //   }
        // },
      ];
    },
    /**
     * grid 내에 체크박스 전체 체크 함수
     * @param {*} field 
     * @param {*} checked 
     */
      allCheckEvnet(field, checked) {
      return this.data = this.data.map(x => {
        x[field] = checked ? 'Y' : 'N';
        return x;
      })
    },
    openReturnTagPrintModal() {
      let _data = this.data.filter(v => v.chk);
      if (_data.length > 0) {
        this.$modal.open({
          component: ReturnTagPrinter,
          parent: this,
          props: {
            returnTagInfo: _data
          },
        });
      } else {
        this.$message.error("선택된 항목이 없습니다.");
      }
    },
    $dismiss() {
      this.$emit('dismiss')
      this.$parent.close()
    },
    onSelectionChangedSub(event) {
      this.gridApiSub = this.mainGridOptions.api;
      const voRow = this.gridApiSub.getSelectedRows() //선택된 Row

      this.mateReturnListDetail = []; // 초기화

      if(voRow[0].outType === 'BadItem'){
        voRow[0].goodQty = voRow[0].badQty;
      }

      this.mateReturnListDetail = voRow[0];
    },
    goOpen() {
      let that = this

      this.$store.commit('loading')
      const vForm = {
        companyId : this.form.companyId,
        startDt : this.form.startDt,
        endDt : this.form.endDt,
        asAgentId : this.form.asAgentId,
        outType : this.form.outType,                     // 반품구분
        procYn : this.form. procYn,                      // 진행단계
        maker : this.form.maker,                         // 제조사
        itemGroup : this.form.itemGroup,
        itemCd : this.form.itemCd,                       // 품번
        sortType : this.form.sortType,                   // 처리유형
        page : this.form.page,
        totalPage : this.form.totalPage,
        totalCount : this.form.totalCount,
        curPage : this.form.curPage,
        processTime : this.form.processTime
      }
      this.$http.post(_url("/api/agent/mateReturnList/list"), vForm)
          .then(response => {
            that.data = response.data.map(x => {
              if(x.outType === 'UseNoItem') {
                x.inBadQty = x.inGoodQty
              }
              return x;
            })
            /* data customize */
            //this.changeData();
          }).finally(() => {
        this.btnSaveChk();
        this.btnCancelChk();

        //this.$refs.mateReturnListInfo.dataClear();
      })
      .finally(() => {
        this.$store.commit('finish');
      });
    },
    /**
     * 반품자재 팝업 오픈
     * *
     */
    openMateReturnWrite() {
      let vm = this;
      this.$modal.open({
        //width: 1500,
        component: MateReturnWrite,
        parent: this,
        props: {
          data: {
            modelNm : vm.form.modelNm
          }
        },
      });
    },
    updateCount(){
      if(!this.$refs.mateReturnListInfo.validation()) return;
      let res = JSON.parse(JSON.stringify(this.$refs.mateReturnListInfo.form));


      let updateForm = {
        companyId  : res.companyId,
        outItemId  : res.outItemId,
        productType  : 'Item',
        outAsAgentId  : res.outAsAgentId,
        outDt  : res.outDt + 'T00:00:00',
        outType  : res.outType,
        itemId  : res.itemId,
        goodQty  : res.goodQty,
        recycleQty  : res.recycleQty,
        badQty  : res.badQty,
        inAsAgentId  : res.inAsAgentId,
        description  : res.description,
        updatorId  : this.$store.state.loginInfo.id
      }


      this.$swal({
        type: 'warning',
        text: '반품자재정보를 수정 하시겠습니까?',
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니요',
      }).then((res) => {
        if(res.value) {
          //this.$store.commit('loading')
          this.$http.post('/api/workMng/mateDelivery/update', updateForm)
              .then(response => {
                this.$swal({type: 'success', text: '수정을 완료 하였습니다.'});
                this.goOpen();
              }).catch((e) => {
            this.$swal({type: 'warning', text: '수정 실패 했습니다.'})
          }).finally(() => {
            this.$store.commit('finish');
          });
        }
      })

    },

    save() {
      //event.preventDefault()
      var list = this.data.filter(v => v.chk === 'Y')
      
      this.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 반품의뢰 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.result = list;
            this.$http.post(_url(`/api/agent/mateReturnList/save`), this.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '반품의뢰를 완료 했습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({ type: 'success', text: '반품의뢰를 실패 했습니다.' })
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '저장할 항목을 선택하세요.' });
      }
    },
    cancel() {
      //event.preventDefault()
      var list = this.data.filter(v => v.chk === 'Y')
      this.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 반품의뢰 취소를 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            this.result = list;
            //alert("outDt : " + this.result.outDt);
            //console.log(list);
            this.$http.post(`/api/agent/mateReturnList/cancel`, this.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '반품의뢰 취소를 했습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({type: 'error', text: e.response.data.message});
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '취소할 항목을 선택하세요.' });
      }
    },
    deleteRow() {
      let vm = this;
      let list = this.data.filter(v => v.chk)
      vm.result = [];
      if(list.length > 0){
        this.$swal({
          type: 'question',
          text: '선택한 항목을 삭제 하시겠습니까?',
          showCancelButton: true
        }).then(r => {
          if (r.value) {
            this.$store.commit('loading')
            vm.result = list;
            this.$http.post(_url(`/api/workMng/mateDelivery/delete`), vm.result)
                .then((response) => {
                  this.$swal({ type: 'success', text: '반품의뢰 취소를 완료 하였습니다.' })
                      .then((result) => {
                        if (result.value) {
                          this.goOpen();
                        }
                      });
                })
                .catch((e) => {
                  this.$swal({ type: 'success', text: '반품의뢰를 실패 하였습니다.' })
                })
                .finally(() => {
                  this.$store.commit('finish')
                });
          }
        })
      } else {
        this.$swal({ type: 'info', text: '삭제할 항목을 선택하세요.' });
      }
    },
    async init() {
      //this.$store.commit('loading');
      await this.$http.post(`/api/agent/mateReturnList/init`)
          .then(response => {
            this.combos['outType'] = response.data.outType;      //반품구분
            this.combos['procYn'] = response.data.procYn;        //진행단계
            this.combos['maker'] = response.data.maker;          //제조사
            this.combos['itemGroup'] = response.data.itemGroup;  //제품군
          }).finally(() => {
            this.goOpen();
            this.$store.commit('finish');
          });
      this.createMainColumnDefs();
    },
    onCatIdChange(param){
      this.form.subCatId = '';
      if(param === '') this.changeCatIdShow =  false;
      else{
        this.changeCatIdShow =  true;
        // 지역 상세
        this.$http.get(`/api/codeMng/combo/catId`, { params: {parentId: param} })
            .then(response => {
              this.combos['subCatId'] = response.data || []
            });
      }
    },
    btnSaveChk(){
      if(this.form.procYn === 'N'){
        this.btnSaveVisible = true;
        this.btnCancelVisible = false;
      } else if (this.form.procYn === 'Y'){
        this.btnSaveVisible = false;
        this.btnCancelVisible = true;
      } else if (this.form.procYn === 'Y'){
        this.btnSaveVisible = false;
        this.btnCancelVisible = true;
      }
    },
    btnCancelChk(){
      if(this.form.procYn === 'Y'){
        this.btnSaveVisible = false;
        this.btnCancelVisible = true;
      } else if(this.form.procYn === 'N'){
        this.btnSaveVisible = true;
        this.btnCancelVisible = false;
      }
    },
    /* data customize */
    changeData(){
      this.data.map((x, i) => {
        let filter = this.combos['outType'].filter(y => y.key === x.outType);
        x.outType = filter[0].value;
      })
    }
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  mounted() {
    this.form.companyId = this.$store.state.loginInfo.compCd;
    this.form.asAgentId = this.$store.state.loginInfo.asAgentId;

  },
  computed: {
    routeName() {
      return this.$route.name
    }
  },
}
</script>


<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}
</style>